import axios from "axios";
// import { logout } from "../creditCardBinAPI/CommonFunctions";

const Call_Api = async (
  routes,
  method,
  param = {},
  token = "",
  options = {}
) => {
  const apiUrl = process.env.REACT_APP_BACKEND_URL;
  const url = `${apiUrl}${routes}`;

  const headers = {
    "Content-Type": "application/json",
  };

  if (token?.trim()) {
    headers.Authorization = `Bearer ${token.trim()}`;
  }

  const config = {
    method,
    url,
    headers,
    timeout: options.timeout ?? 15000, // ✅ default 15s, overrideable
  };

  if (["POST", "PUT", "PATCH"].includes(method)) {
    config.data = param;
  }

  if (["GET", "DELETE"].includes(method)) {
    const queryParams = new URLSearchParams(param).toString();
    if (queryParams) {
      config.url = `${url}?${queryParams}`;
    }
  }

  try {
    const response = await axios(config);
    return { success: true, response: response.data };
  } catch (error) {
    // if (error?.response?.status === 401) {
    //     await logout();
    // }

    if (error.code === "ECONNABORTED") {
      return {
        success: false,
        message: "Request timed out. Please try again.",
      };
    }

    if (!error.response) {
      return {
        success: false,
        message: "Server not responding. Please try again.",
      };
    }

    console.error("API call error:", error);

    return {
      success: false,
      message:
        error.response.data?.message ||
        `Request failed (${error.response.status})`,
    };
  }
};

export default Call_Api;
